/* Style Mobo — Recently Viewed Products (localStorage) */

const SM_RV_KEY = 'sm_recently_viewed_v1';
const SM_RV_MAX = 8;

const SMRecentlyViewed = {
  _items: null,

  get items() {
    if (!this._items) {
      try {
        this._items = JSON.parse(localStorage.getItem(SM_RV_KEY) || '[]');
      } catch {
        this._items = [];
      }
    }
    return this._items;
  },

  track(product) {
    /* product: { id, handle, title, price, image, url } */
    const id = String(product.id);
    this._items = this.items.filter(i => String(i.id) !== id);
    this._items.unshift(product);
    if (this._items.length > SM_RV_MAX) this._items = this._items.slice(0, SM_RV_MAX);
    try {
      localStorage.setItem(SM_RV_KEY, JSON.stringify(this._items));
    } catch {}
  },

  getExcluding(id) {
    return this.items.filter(i => String(i.id) !== String(id));
  }
};

/* Auto-track on product pages */
document.addEventListener('DOMContentLoaded', () => {
  const meta = document.querySelector('[data-sm-product-meta]');
  if (!meta) return;
  try {
    const product = JSON.parse(meta.textContent);
    SMRecentlyViewed.track(product);
  } catch {}
});

/* Render recently-viewed section */
class SMRecentlyViewedSection extends HTMLElement {
  connectedCallback() {
    const currentId = this.dataset.currentId;
    const items = SMRecentlyViewed.getExcluding(currentId);

    if (items.length === 0) {
      this.hidden = true;
      return;
    }

    this.hidden = false;
    this.innerHTML = `
      <div class="sm-rv__scroller">
        ${items.map(item => `
          <a href="${item.url}" class="sm-rv__item">
            <div class="sm-rv__img-wrap sm-product-img-wrap">
              <img
                src="${item.image}"
                alt="${item.title}"
                width="160"
                height="160"
                loading="lazy"
              >
            </div>
            <div class="sm-rv__info">
              <span class="sm-rv__title">${item.title}</span>
              <span class="sm-rv__price">${SMUtils.formatMoney(item.price)}</span>
            </div>
          </a>
        `).join('')}
      </div>
    `;
  }
}
customElements.define('sm-recently-viewed', SMRecentlyViewedSection);

window.SMRecentlyViewed = SMRecentlyViewed;
